export default __webpack_public_path__ + "static/media/019-smoke-detector.439769bf.png";